import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { resetParts } from "../../../redux/partSlice";
import { openCopyReplace } from "../../../redux/previewSlice";
import { resetSteps } from "../../../redux/stepSlice";
import { getRevAllNodes } from "../../../redux/procedureRevisionSlice";
import Loader from "../../../common/Loader";
import VersionHistoryCopyAppBar from "../../../common/VersionHistoryCopyAppBar";
import SelectRevisionTable from "../../NodeActions/assets/components/SelectRevision/SelectRevisionTable";

const MovePreviewCopySelectProcedure = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.parts);
  const { sections: fetchedSections, stepsBySection: fetchedStepsBySection, substepsByStep: fetchedSubstepsByStep, richTexts: fetchedRichTexts, attachments: fetchedAttachments, canvases: fetchedCanvases, forms: fetchedForms, videos: fetchedVideos } = useSelector((state) => state.step);
  const location = useLocation();

  const {
    title,
    partNumber,
    revision: fromRevision,
    partId,
    siblingOrder,
    fromSectionId,
    fromStepId,
    fromSubstepId,
    type,
    description,
    elementType,
    id,
    section,
    steps,
    sections,
    richTextsByStep,
    attachmentsByStep,
    canvasesByStep,
    formsByStep,
    videosByStep,
    stepId,
    sectionId,
    status,
    sourceSubstepIndex,
    sourceStepId,
    sourceNodeId,
    targetSubstepIndex,
    targetStepId,
    targetNodeId,
    sourceNodeIndex,
    sourceSectionIndex,
    sourceStepIndex,
    revisionId,
    fromTreeId,
    fromSiblingOrder,
    step,
    fromStepSiblingOrder,
    fromStepTreeId,
    fromSubstepTreeId,
    fromSubstepSiblingOrder,
    elementId,
    elementTreeId,
    substep,
    forms,
    attachments,
    canvases,
    richTexts,
    videos,
    nodeType,
    node,
    substepsByStep,
    childTreeId,
    fromSubstepLetter,
    newData,
    pageTitle,
    shortDescription,
    sectionDetailsPreview,
    bomTableTitle,
    partNumberColumnTitle,
    partDetailsPreview,
  } = location.state || {};

  // Debug logging to understand the routing context
  useEffect(() => {
  }, [location.state]);

  // Fetch rich data structure for move preview flow
  useEffect(() => {
    if (partId && revisionId) {
      dispatch(getRevAllNodes({ 
        partId, 
        revisionId,
        otherParams: `is_move_preview=true`
      }));
    }
  }, [dispatch, partId, revisionId]);

  // Handle revision selection - extracted from table row click handler
  const handleRevisionSelect = ({ group, revision }) => {
    // Use Redux openCopyReplace action like the working flow
    dispatch(openCopyReplace({
      copyMode: "node",
      sourceDocument: {
        partId: group.partId,
        revisionId: revision.id || "",
        partNumber: group.partNumber,
        revision: revision.label,
        type: group.type,
        description: group.description,
      },
      sourceNode: {
        nodeId: stepId || sourceStepId || id,
        nodeType: 'step',
        nodeTitle: pageTitle || title,
        sectionId: sectionId || fromSectionId,
        stepId: stepId || sourceStepId || id,
        // Include all the rich data for the step
        ...location.state.copyData ? {
          richTexts: location.state.copyData.richTextsByStep?.[stepId || sourceStepId || id] || [],
          forms: location.state.copyData.formsByStep?.[stepId || sourceStepId || id] || [],
          videos: location.state.copyData.videosByStep?.[stepId || sourceStepId || id] || [],
          attachments: location.state.copyData.attachmentsByStep?.[stepId || sourceStepId || id] || [],
          canvases: location.state.copyData.canvasesByStep?.[stepId || sourceStepId || id] || [],
          substeps: location.state.copyData.substepsByStep?.[stepId || sourceStepId || id] || [],
        } : {}
      }
    }));
    
    // Navigate to step copy screen
    navigate('/procedure-step-copy-move-preview', { 
      state: {
        ...location.state,
        // Copy data for the move preview flow - use fetched data if available, fallback to location.state
        copyData: {
          sections: fetchedSections || sections,
          stepsBySection: fetchedStepsBySection || steps || {},
          substepsByStep: fetchedSubstepsByStep || substepsByStep,
          richTextsByStep: fetchedRichTexts || richTextsByStep,
          attachmentsByStep: fetchedAttachments || attachmentsByStep,
          canvasesByStep: fetchedCanvases || canvasesByStep,
          formsByStep: fetchedForms || formsByStep,
          videosByStep: fetchedVideos || videosByStep,
        },
        // Step-specific data for copy flow
        stepId: fromStepId || sourceStepId || id,
        stepTitle: pageTitle || title,
        elementType: 'step',
        // Target document info
        toPartNumber: group.partNumber,
        toRevision: revision.label,
        toRevisionId: revision.id || "",
        partId: group.partId,
        revisionId: revision.id || "",
      }
    });
  };

  return (
    <div>
      {loading && <Loader text="Loading documents..." />}
      <VersionHistoryCopyAppBar
        title={`Copy ${pageTitle || 'Step'} from ${partNumber || 'Document'} ${fromRevision || ''}`}
        showTablesDropdown={false}
        subheadingBelowTitle={location.state.copyTitle || pageTitle || ''}
        showCancelButton={true}
        showBackButton={false}
        showProfileButton={false}
      />
      
      {/* Use the SelectRevisionTable component to show document selection */}
      <div style={{ marginTop: "24px" }}>
        <SelectRevisionTable
          sourcePartNumber={partNumber}
          onRevisionSelect={handleRevisionSelect}
          fromRevision={fromRevision}
        />
      </div>
    </div>
  );
};

export default MovePreviewCopySelectProcedure;
